import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { parse } from 'query-string';
import { OneloginContext } from '../../../utils/OneLogin/context';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../../redux/actions/user';

//TODO onelogin state/nonce checks, proper error handling
export const OneLoginFlow = (props) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch()
  const { oneloginSec } = React.useContext(OneloginContext);

  const oneloginResponse = parse(location.hash);
  // console.log('ONELOGIN USER: ', decode(oneloginResponse.id_token));

  const handleLogin = async (json) => {
    // prevent cross site scripting attacks
    if (oneloginResponse.state !== oneloginSec.state) {
      history.push('/login');
      return null;
    }

    const response = await fetch(`${(window as any)._env_.REACT_APP_SERVER}/auth/onelogin/login`, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json),
      credentials: 'include',
    });

    if (response.ok) {
      const data = await response.json();

      if (data.accessToken) {
        dispatch(loginUser(data))
        handleRedirect();
      } 
    }
  };

  //prevent back button from getting to previous page
  const handleRedirect = () => {
    if (location.state !== undefined) {
      if ((location.state as any).from !== undefined) {
        history.push((location.state as any).from.pathname);
      } else {
        history.push('/');
      }
    } else {
      history.push('/');
    }
  };

  // const errorMessage = () => {
  //   if (errorOnLogin) {
  //     return (
  //       <div className='alert alert-danger' role='alert'>
  //         <p>An error occurred while trying to login.</p>
  //       </div>
  //     );
  //   }
  // };

  handleLogin(oneloginResponse);

  return null;

}